// extracted by mini-css-extract-plugin
module.exports = {"item":"style-module--item--2BUDG","itemList":"style-module--itemList--1DpeG","icon":"style-module--icon--xpBfj","label":"style-module--label--9HFVr"};